<template>
  <v-navigation-drawer
    v-model="$root.$data.drawerIsActive"
    fixed
    overflow
    app
  >
    <navigation-list />
    <!-- end navigation-list -->
  </v-navigation-drawer>
  <!-- end navigation-drawer -->
</template>

<script>
import NavigationList from './NavigationList'
export default {
  components: {
    NavigationList
  }
}
</script>
